// extracted by mini-css-extract-plugin
module.exports = {"langs":"I18nInput_langs__1LPRH","lang":"I18nInput_lang__3PitF","selected":"I18nInput_selected__1A4zO","filled":"I18nInput_filled__2__p6"};